// Firma sabitleri

export const HAZARD_CLASSES = [
  { value: 'az_tehlikeli', label: 'Az Tehlikeli', color: 'bg-emerald-100 text-emerald-700' },
  { value: 'tehlikeli', label: 'Tehlikeli', color: 'bg-amber-100 text-amber-700' },
  { value: 'cok_tehlikeli', label: 'Çok Tehlikeli', color: 'bg-rose-100 text-rose-700' },
];

export const COMPANY_DOCS = [
  { key: 'sgk_hizmet_listesi', label: 'SGK Hizmet Listesi', hasDate: true },
  { key: 'isg_katip_uzman', label: 'İSG Katip Uzman', hasDate: false },
  { key: 'isg_katip_hekim', label: 'İSG Katip Hekim', hasDate: false },
];

// Firmalar ekranında takip edilen firma profil belgeleri
export const COMPANY_PROFILE_DOCS = [
  { key: 'vergi_levhasi', label: 'Vergi Levhası', hasDate: false },
  { key: 'kvkk_taahhutnamesi', label: 'KVKK Taahhütnamesi', hasDate: false },
  { key: 'ust_isveren_vekili', label: 'Üst İşveren Vekili', hasDate: false },
];

export const DOC_STATUS_OPTIONS = [
  { value: 'onay', label: 'Onay', color: 'bg-emerald-100 text-emerald-700' },
  { value: 'eksik', label: 'Eksik', color: 'bg-rose-100 text-rose-700' },
  { value: 'beklemede', label: 'Beklemede', color: 'bg-amber-100 text-amber-700' },
];

export const getHazardClassInfo = (value) => {
  return HAZARD_CLASSES.find(h => h.value === value) || HAZARD_CLASSES[1];
};

export const getDocStatusColor = (status) => {
  const option = DOC_STATUS_OPTIONS.find(o => o.value === status);
  return option?.color || 'bg-slate-100 text-slate-700';
};
